import { customerPoFollowUpOrder } from '@/utils/shared'
export const config = (orderBy) => ({
  id: 'customer-po-followup',
  isAutoLoad: false,
  isAsyncGet: true,
  store: {
    get: {
      selected: [
        'id',
        'po', 'partID', 'partSN', 'reminderDate',
        'orderPhaseID', 'orderPhasePersonInChargeEmployeeID', 'dateInPhase', 'priorityID', 'lastInfo',
        'exchAgreementSigned', 'unitShipped', 'coreReceived', 'repairCostsApproved', 'unitReceivedCustomer',

        'rfq3.id as rfq3ID',
        'rfq3.price', 'rfq3.currencyID',
        'rfq3.conditionID', 'rfq3.quoteDate', 'rfq3.supplyDate', 'rfq3.tagInfoCompanyID',
        'rfq3.tagDate', 'rfq3.traceabilityCompanyID', 'rfq3.remarks', 'rfq3.exchangeCoreValue',
        'rfq3.exchangeCoreValueCurrencyID', 'rfq3.exchangeConditionID',
        'rfq3.exchangeCoreReceived', 'rfq3.coreDueDate', 'rfq3.stockID', 'rfq3.qty',

        'rfq3.rfq.id as rfqID',
        'rfq3.rfq.rfqid as rfqid', 'rfq3.rfq.rfqTypeID',
        'rfq3.rfq.requestedDate',
        'rfq3.rfq.customerCompanyID',
        'rfq3.rfq.customerContactID',
        'rfq3.rfq.observation'
      ],
      url: 'CustomerPOFollowUps/GetAllDynamic',
      filters: 'rfq3.rfq.poIsOpen = true',
      orderBy: customerPoFollowUpOrder(orderBy)
    },
    create: {
      url: 'CustomerPOFollowUps/Create'
    },
    patch: {
      url: (data) => `CustomerPOFollowUps/Patch/${data.id}`
    },
    delete: {
      url: (data) => `CustomerPOFollowUps/Delete/${data.id}`
    }
  },
  autoSave: {
    url: (data) => `CustomerPOFollowUps/Patch/${data.id}`
  },
  header: {
    isVisible: false
  },
  content: {
    isScroll: false
  },
  controls: {
    isVisible: false
  },
  footer: {
    isVisible: true,
    pagination: {
      isVisible: true,
      size: 5,
      sizes: {
        isVisible: true,
        values: [
          { 'label': '3', 'value': 3 },
          { 'label': '5', 'value': 5 },
          { 'label': '10', 'value': 10 },
          { 'label': '20', 'value': 20 }
        ]
      }
    }
  }
})
